import { If } from 'shared';

import AccountList from './AccountList';
import { Arrow } from './styles';

interface IProps {
  isOpen: boolean;
}

export const SwitchAccount = ({ isOpen }: IProps) => {
  return (
    <div>
      <Arrow direction={isOpen} />
      <If condition={isOpen}>
        <AccountList />
      </If>
    </div>
  );
};
